module.exports = __webpack_public_path__ + "img/safe_8_percent.c3546380.png";